/* eslint-disable operator-linebreak */
/* eslint-disable no-invalid-this */
// Libraries
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getId } from '../../../utils/helperMethods';

const RadioContainer = styled.div`
    opacity: ${props => (props.disabled ? '0.6' : '1')};
`;
const LabelWrapper = styled.label`
    color: #5c5c5c;
    display: inline-block;
    font-size: $font-size-sm;
    margin-right: 50px;
    position: relative;
`;

const RadioWrapper = styled.input`
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    opacity: 0;
    position: absolute;
`;

const CustomIconWrapper = styled.span`
    background-size: cover;
    border: 1px solid #c2bcbf;
    border-color: ${props => (props.isSelected ? `#ed7f31` : `#c2bcbf`)};
    border-radius: 50%;
    display: inline-block;
    height: 17px;
    margin-right: 12px;
    width: 17px;

    span {
        background: ${props => (props.isSelected ? `#ed7f31` : `transparent`)};
        border-radius: 50%;
        display: inline-block;
        height: 9px;
        margin-left: 3px;
        margin-top: 3px;
        width: 9px;
    }
`;

const LabelTextWrapper = styled.span`
    display: inline-block;
    margin-top: 2px;
    vertical-align: top;
`;

const StyledErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const Radio = props => {
    const {
        id,
        input,
        defaultSelected,
        wrapperClass,
        className,
        options,
        valueField,
        labelField,
        handleChange,
        hideErrors,
        meta,
        disabled = false,
    } = props;

    const [selectedValue, setSelectedValue] = useState(defaultSelected || '');

    useEffect(() => {
        if (defaultSelected && input) {
            input.onChange(defaultSelected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultSelected]);

    function handleRadioChange(item) {
        if (input) {
            input.onChange(item[valueField]);
        } else {
            handleChange && handleChange(selectedValue);
            setSelectedValue(item[valueField]);
        }
    }

    const isSelected = item =>
        // eslint-disable-next-line implicit-arrow-linebreak
        input
            ? input.value === item[valueField]
            : selectedValue === item[valueField];

    return (
        <RadioContainer className={wrapperClass || ''} disabled={disabled}>
            {options &&
                options.length &&
                options.map((item, index) => (
                    <LabelWrapper
                        key={index}
                        className={`${isSelected(item) ? 'selected' : ''}`}
                    >
                        <RadioWrapper
                            id={id || getId(item[labelField])}
                            className={className || ""}
                            type="radio"
                            name="radioOption"
                            value={item[valueField]}
                            checked={isSelected(item)}
                            onChange={handleRadioChange.bind(this, item)}
                            disabled={disabled}
                        />
                        <CustomIconWrapper
                            className={`custom-icon ${isSelected(item) ? 'selected' : ''
                                }`}
                            isSelected={isSelected(item)}
                        >
                            <span />
                        </CustomIconWrapper>
                        <LabelTextWrapper className="label-text">
                            {item[labelField]}
                        </LabelTextWrapper>
                    </LabelWrapper>
                ))}
            {!hideErrors && meta && meta.touched && meta.error && (
                <StyledErrorWrapper className="error-message">
                    {meta.error}
                </StyledErrorWrapper>
            )}
        </RadioContainer>
    );
};

Radio.propTypes = {
    className: PropTypes.string,
    defaultSelected: PropTypes.string,
    handleChange: PropTypes.func,
    input: PropTypes.node,
    labelField: PropTypes.string,
    options: PropTypes.array,
    valueField: PropTypes.string,
    wrapperClass: PropTypes.string,
    hideErrors: PropTypes.bool,
    meta: PropTypes.object,
    disabled: PropTypes.bool,
};

export default Radio;
